import searchAddress from '../api/poi'
import R from 'ramda'
import debounce from 'lodash.debounce'
import {defineMessages} from 'react-intl'

import addNotification from './addNotification'

const messages = defineMessages({
  title: {
    id: 'Oops', 
    defaultMessage: 'Oops'
  },
  message: {
    id: "It seams that the search doesn't work at the moment, try again later", 
    defaultMessage: "It seams that the search doesn't work at the moment, try again later"
  }
})
const notification = {title: messages.title, type: 'error', message:messages.message} 
const respHandler = dispatch => (err, res) => {
  if(err) {
    dispatch({type: 'toggle_searching_poi', value: false})
    dispatch(addNotification(notification))
    return console.error("Failed to search for poi by address", err)
  }
  const searchResults = res || [];
  dispatch({type: 'load_poi_options', options: searchResults})
  dispatch({type: 'toggle_searching_poi', value: false})
}

const runSearch = (address, dispatch) => {
  searchAddress(address, respHandler(dispatch))
}

const debouncedRunSearch = debounce(runSearch, 700)

export default (address) =>  (dispatch, getState) => {
    
  const searchingPoi = getState().searchingPoi; 
  dispatch({type: 'poi_search_change', address})
  if(address === "") {      
    if(searchingPoi) {
       dispatch({type: 'toggle_searching_poi', value: false})
    }    
    return dispatch({type: 'load_poi_options', options: []})
  }
  else if(!searchingPoi){
    dispatch({type: 'toggle_searching_poi', value: true})
  }
  debouncedRunSearch(address, dispatch)
}



/** WEBPACK FOOTER **
 ** ./app/actions/searchPOIByAddress.js
 **/